export default __webpack_public_path__ + "static/media/iot.96dab1dc.jpg";